export const size_of_raw_materials = [
    {
        label: '240x60',
        w: 240,
        h: 60,
    },
    {
        label: '120x80',
        w: 120,
        h: 80,
    },
    {
        label: '120x60',
        w: 120,
        h: 60,
    },
    {
        label: '80x60',
        w: 80,
        h: 60,
    },
    {
        label: '60x60',
        w: 60,
        h: 60,
    },
    {
        label: '90x90',
        w: 90,
        h: 90,
    },
    {
        label: '90x45',
        w: 90,
        h: 45,
    },
]

export const size_frames = [
    {
        label: '23x4',
        w: 23,
        h: 4,
    },
    {
        label: '20x4',
        w: 20,
        h: 4,
    },
    {
        label: '11x4',
        w: 11,
        h: 4,
    },
    {
        label: '10x4',
        w: 10,
        h: 4,
    },
    {
        label: '6x4',
        w: 6,
        h: 4,
    },
    {
        label: '25x3',
        w: 25,
        h: 3,
    },
    {
        label: '19x3',
        w: 19,
        h: 3,
    },
    {
        label: '14x3',
        w: 14,
        h: 3,
    },
    {
        label: '13x3',
        w: 13,
        h: 3,
    },
    {
        label: '10x3',
        w: 10,
        h: 3,
    },
    {
        label: '7x3',
        w: 7,
        h: 3,
    },
    {
        label: '10x2',
        w: 10,
        h: 2,
    },
    {
        label: '8x2',
        w: 8,
        h: 2,
    },
    {
        label: '5x2',
        w: 5,
        h: 2,
    },
    {
        label: '4x2',
        w: 4,
        h: 2,
    },
]